import { InfoSet } from "../InfoSets/InfoSet";
import { InfoSetTable } from "../InfoSets/InfoSetTable";
import { StringUtils } from "../Utils/StringUtils";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class AttributeNames {
    public static get PrtgGroupID(): string { return "prtg_group_id"; }
    public static get PrtgDeviceID(): string { return "prtg_device_id"; }
}
    
//export interface AttributeEntryJson {
//    attribute_name: string;
//    attribute_value: string;
//}

export class AttributeEntry /*implements ISerializable*/ implements ObjectSerializer {
    public Name: string;
    public Value: string;

    constructor() {
        this.Name = "";
        this.Value = "";
    }

    //public Deserialize(json: AttributeEntryJson): void {
    //    if (json.attribute_name !== undefined) {
    //        this.Name = json.attribute_name;
    //    }

    //    if (json.attribute_value !== undefined) {
    //        this.Value = json.attribute_value;
    //    }
    //}
        
    //public static FromJson(json: any) {
    //    var result = new AttributeEntry();
    //    result.Deserialize(json);
    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.attribute_entry = {};
		obj = obj.attribute_entry

		obj.attribute_name = this.Name;
		obj.attribute_value = this.Value;
	}

	public Read(obj: any, context: any): void {
		if (!obj.attribute_entry)
			throw new Error();
		obj = obj.attribute_entry;

		if (obj.attribute_name !== undefined)
			this.Name = obj.attribute_name;

		if (obj.attribute_value !== undefined)
			this.Value = obj.attribute_value;
	}
}

export class AttributeInfo extends InfoSetTable<string, AttributeEntry> {

    public AddAttribute(attrName: string, attrValue: string): boolean {
        if (StringUtils.IsNullOrEmpty(attrName))
            return false;
        if (StringUtils.IsNullOrEmpty(attrValue))
            return false;
            
        var attrEntry = new AttributeEntry();
        attrEntry.Name = attrName;
        attrEntry.Value = attrValue;

        return this._table.Add(attrName, attrEntry);
    }
        
    public AddEntry(attrEntry: AttributeEntry): boolean {
        if (attrEntry == null)
            return false;

        return this._table.Add(attrEntry.Name, attrEntry);
    }

    public GetAttribute(attrName: string): string {
        var result = "";
        var entry = this.GetValue(attrName);
        if (entry != null) {
            result = entry.Value;
        }
        return result;
    }

    //public EntryName(): string {
    //    return "attribute_entry";
    //}

    //public DeserializeEntry(json:any): void {
    //    var entry = new AttributeEntry();
    //    entry.Deserialize(json);
    //    this.AddEntry(entry);
    //}

    //public static FromJson(json: any, device:Device): AttributeInfo {
    //    var attributeInfo = new AttributeInfo(device);
    //    attributeInfo.Deserialize(json);
    //    return attributeInfo;
    //}

	public Write(obj: any, context: any): void {
		obj.attr_info = {};
		obj = obj.attr_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._table.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.attr_info)
			throw new Error();
		obj = obj.attr_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new AttributeEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}
}
